import { render } from "./ForgetPass.vue?vue&type=template&id=18fca1ee"
import script from "./ForgetPass.vue?vue&type=script&lang=js"
export * from "./ForgetPass.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__